// import globalPrefix from 'global-prefix';

// /opt/homebrew/lib/node_modules
// export const getNpmGlobal = () => `${globalPrefix}/lib`;
export const getNpmGlobal = () => `/opt/homebrew/lib/`;
